// The account role, read from the Auth0 ID token.
//
// The claim string was repeated verbatim in four components, so it had four chances to rot.
// Everything here mirrors isOwner() in agenthelper-api's server/auth/permissions.js: "admin"
// is Swifteq staff acting on a customer's account, and passes wherever an owner does.
//
// This is convenience, never enforcement. The server checks the same claim out of the JWT and
// is what actually refuses; hiding a control here only saves someone a pointless click.

export const ROLE_CLAIM = 'https://www.swifteq.com/role'

export function getAccountRole(user) {
  return (user || {})[ROLE_CLAIM] || null
}

export function isOwnerRole(user) {
  const role = getAccountRole(user)
  return role === 'owner' || role === 'admin'
}
